import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/site";

// Logo: uses custom uploaded/URL logo from admin settings if present, otherwise renders the default SVG.
export default function Logo({ size = 40, variant = "light" }) {
  const bg = variant === "light" ? "#1B3626" : "#C49A6C";
  const fg = variant === "light" ? "#FFFFFF" : "#0F1210";
  const accent = variant === "light" ? "#C49A6C" : "#1B3626";
  const { data: gen } = useQuery({ queryKey: ["settings","general","logo"], queryFn: async () => (await api.get("/settings/general")).data, staleTime: 300000 });
  const custom = gen?.value?.logo_id
    ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${gen.value.logo_id}`
    : (gen?.value?.logo_url || "");

  if (custom) {
    return (
      <img
        src={custom}
        alt="Logo"
        style={{ width: size, height: size, objectFit: "contain", borderRadius: 9 }}
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="48" height="48" rx="9" fill={bg} />
      <path d="M8 24 L24 12 L40 24" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 26 L24 18 L34 26" stroke={fg} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" opacity="0.9" />
      <path d="M17 38 V29 M17 29 L31 38 M31 38 V29" stroke={fg} strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Small helper — displays company name + tagline pulled from admin settings, with sensible defaults.
export function BrandText({ compact = false, className = "" }) {
  const { data: gen } = useQuery({ queryKey: ["settings","general","brand-text"], queryFn: async () => (await api.get("/settings/general")).data, staleTime: 300000 });
  const name = gen?.value?.company_name || "NOUROZI";
  const tagline = gen?.value?.company_tagline || "EBYGG & ANLEGG";
  return (
    <div className={`leading-tight ${className}`}>
      <div className={`font-display font-extrabold tracking-tight ${compact ? "text-[15px]" : "text-lg"}`}>{name}</div>
      <div className="text-[10px] font-semibold tracking-[0.18em] text-[#555E68]">{tagline}</div>
    </div>
  );
}
